* {
  box-sizing: border-box;
}

.container {
  width: 100%;
  position: relative;

  > * {
    width: 100%;
  }
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.date-input {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 10px;
  width: 60%;
  background-color: var(--color-white);
  display: none;
  border: none;

  &.focus, &:focus, &:focus-visible {
    outline: none;
    display: block;
  }
}

select {
  display: none;
}

.dropdown {
  position: relative;

  @include focus;

  .date-picker-input {
    @include text-main;
    line-height: 40px;
    font-size: 1.4rem;
    background-color: var(--color-light-grey);
    border: 0;
    border-radius: 5px;
    box-shadow: none;
    outline: none !important;
    padding: 0 0 0 15px;
    width: 100%;
    position: relative;
    overflow: hidden;
    text-align: left;
    cursor: pointer;

    .icon {
      position: absolute;
      top: 1px;
      right: 20px;
      border: 0;
      vertical-align: middle;
      font-size: var(--font-size-icon-m);

      &:before {
        content: '\e927';
        font-family: var(--font-icons);
      }
    }

    span {
      font-size: var(--font-size-small-text);
    }
  }

  &.visible {
    .calendar-container {
      display: block;
      z-index: 1000;
    }
  }

  .calendar-container {
    display: none;
    position: relative;
    width: 100%;
  }

  .reset-date {
    position: absolute;
    top: 9px;
    right: 50px;
    border: 0;
    vertical-align: middle;
    font-size: var(--font-size-icon-m);
    line-height: var(--font-size-icon-m);
    cursor: pointer;
    background: var(--color-transparent);

    .reset-icon:before {
      content: '\e938';
      font-family: var(--font-icons);
      color: var(--color-dark-grey);
    }

    .reset-icon:hover {
      &:before {
        color: var(--color-darker-grey);
      }
    }
  }
}

.white {
  .date-picker-input {
    background-color: var(--color-white);
    border: 1px solid var(--color-grey);
  }

  label, span {
    color: var(--font-color-main);
  }
}

.calendar {
  max-width: 360px;
  font-family: var(--font-main);
  padding: 1rem;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--color-white);
  border: 1px solid var(--color-grey);
  border-top: 0;
  border-radius: 0 0 5px 5px;
  box-shadow: var(--color-grey) 2px 2px 4px 0;

  > * {
    line-height: 35px;
  }

  span {
    flex-grow: 30;
    width: calc((100% / 7) - 4px);
    margin: 2px;
    text-align: center;
    color: var(--color-dark-grey);
  }
}

header {
  display: flex;
  justify-content: space-between;
  color: var(--color-dark-grey);
  font-weight: bold;
  font-size: var(--font-size-main-text);

  span:first-child,
  span:last-child {
    flex-grow: .1;
    cursor: pointer;
  }
}

footer {
  display: flex;
  justify-content: center;
}

.day-names {
  display: flex;
  @include text-bold;
  color: var(--color-grey);
}

.days-in-month {
  display: flex;
  flex-wrap: wrap;

  span {
    cursor: pointer;
    position: relative;
    color: var(--font-color-main);

    &.disabled {
      color: var(--color-grey);
      cursor: default;
    }

    &.fillMonth {
      color: var(--color-light-grey);
      cursor: default;
    }
  }

  i {
    display: inline-grid;
    font-style: normal;
    position: relative;
    height: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 5px;
    justify-content: center;
    align-items: center;

    &.active {
      border: 2px solid var(--color-grey);
    }

    &.selected {
      background: var(--color-red);
      color: var(--color-white);
    }
  }

  span:hover:not(.disabled) i:not(.selected) {
    background: var(--color-grey);
  }

  i.has-event:before {
    content: ' \25CF';
    font-size: .7rem;
    position: absolute;
    top: .4rem;
    left: 1.18rem;
    color: var(--color-red);
  }

  i.selected.has-event:before {
    color: var(--color-white);
  }

  i.active.has-event:before {
    top: .1rem;
    left: 1.1rem;
  }
}

@include button-prev-next('.button');

.date-picker .button {
  border-radius: 5px;
}

.btn-today {
  border-radius: 5px;
  height: 30px;
  width: fit-content;
  padding: 3px 10px;
  @include text-bold;
  color: var(--color-darker-grey);

  &:hover {
    color: var(--color-white);
  }
}

@include validation-error-styles;

@include media-max-width($breakpoint-s) {
  .calendar {
    max-width: 100%;
  }
}
